/**
 * Created by isuru on 20/12/2021.
 */
(function () {
  'use strict';

  angular
    .module('crewSchedule')
    .controller('crewScheduleNotificationCtrl', crewScheduleNotificationCtrl);

  function crewScheduleNotificationCtrl(CommonMasterData, modalParams,$uibModalInstance,CrewingHelper, MessageService) {
    var vm = this;

    vm.model = {
      message : modalParams.message,
      profileId : modalParams.profileId,
      notify : modalParams.disableSendYes,
      send : modalParams.disableSendYes === "false" ? null : "true",
      channel : ['E','N','S'],
      channel1 : modalParams.disableSendYes === "true",
      channel2 : modalParams.disableSendYes === "true",
      channel3 : modalParams.disableSendYes === "true",
      user : modalParams.user,
      telephone : modalParams.telephone,
      later : null,
      crewSchdChangeId: modalParams.crewSchdChangeId,
      disableChannels : modalParams.disableSendYes === "false",
      dutyChangeTextAreaShow: false,
      dutyChangeReasons : null,
      dutyChangeOtherReason : modalParams.dutyChangeOtherReason,
      dutyChangeReasonDropDownValidation : false,
      dutyChangeReason : modalParams.message.includes("removed") ? {dropdownId : 2, dropdownName: 'Operational', dropdownValue: 'Operational'}
        : !!modalParams.dutyChangeReason?modalParams.dutyChangeReason:null,
      pushNotificationMessage : modalParams.pushNotificationMessage
    };

    vm.onCloseClick = function () {
      $uibModalInstance.close(modalParams.close);
    }

    vm.onNoClick = function (){
      vm.model.channel1 = false;
      vm.model.channel2 = false;
      vm.model.channel3 = false;
      vm.model.send = null;
      vm.model.disableChannels = true;
    }

    vm.onYesClick = function (){
      vm.model.channel1 = true;
      vm.model.channel2 = true;
      vm.model.channel3 = true;
      vm.model.send = "true";
      vm.model.disableChannels = false;
    }

    vm.checkMandetoryFieldVaidation = function () {

      if(vm.model.dutyChangeReason === undefined || vm.model.dutyChangeReason === null) {
        return false;
      } else {
        if(vm.model.dutyChangeReason.dropdownValue === 'Other') {
          if(vm.model.dutyChangeOtherReason != null) {
            return true;
          } else {
            return false;
          }
        }
        return true;
      }

    }

    vm.onProceedClick = function () {

      vm.model.dutyChangeReasonDropDownValidation = false;

      if(!vm.checkMandetoryFieldVaidation()) {
        vm.model.dutyChangeReasonDropDownValidation = true;
        return;
      }

      var c = [];
      if(vm.model.channel1){
        c.push("E");
      }
      if(vm.model.channel2){
        c.push("N");
      }
      if(vm.model.channel3){
        c.push("S");
      }

      var para = {
        crewProfileId : vm.model.profileId,
        message : vm.model.message,
        sendNow : (vm.model.send==="true")?true:false,
        notfy : (vm.model.notify==="true")?true:false,
        channel: c,
        sendTime : vm.model.later,
        crewSchdChangeId : vm.model.crewSchdChangeId,
        dutyChangeReasonId : vm.model.dutyChangeReason.dropdownId,
        dutyChangeReason : vm.model.dutyChangeOtherReason,
        pushNotificationMessage : vm.model.pushNotificationMessage
      }
        CrewingHelper.notifyCrewScheduleChange(para,
          function () {
            MessageService.success(MessageService.MESSAGES.SEND_NOTIFICATION.NOTIFICATION_SEND_SUCCESS);
            $uibModalInstance.close();
          },
          function (error) {
            MessageService.error(MessageService.MESSAGES.SEND_NOTIFICATION.NOTIFICATION_SEND_FAIL);
          }
        );
      $uibModalInstance.close(modalParams.close);
    };

    vm.onRosterReasonChange = function (){
      console.log(vm.model.dutyChangeReason.dropdownValue);
      if(vm.model.dutyChangeReason.dropdownValue === 'Other') {
        vm.model.dutyChangeTextAreaShow = true;
      } else {
        vm.model.dutyChangeTextAreaShow = false;
      }

    };

    ( // load the duty change reasons from the db
      // pass the dropdownid and tenant name
      function loadRosterChangeReasons() {
        CommonMasterData.getDropDownList(1, 'ALL', function(reasons) {
          vm.model.dutyChangeReasons = reasons;
          console.log(vm.model.dutyChangeReasons);

          // If modalParams has a dutyChangeReason, find and set the matching option
          if (modalParams.dutyChangeReason && modalParams.dutyChangeReason) {
            var matchingReason = reasons.find(function(reason) {
              return reason.dropdownValue === modalParams.dutyChangeReason;
            });
            if (matchingReason) {
              vm.model.dutyChangeReason = matchingReason;
            }
          }
        }, function() {
          console.log('Roster change reasons retrieval error');
        });
      })();


  }
}());
